import ReactDOM from 'react-dom/client';

import 'antd/dist/reset.css';
import './index.css';
import './common/sentry/init';

import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
